import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Cpu, DollarSign, TrendingUp, Ticket, Rocket } from 'lucide-react';

function formatMoney(n, decimals = 2) {
  return `$${Number(n || 0).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
}

export default function BusinessValueMetrics({ savings, tokenUsage }) {
  const deploys = tokenUsage?.total_deploy_count ?? 0;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4" data-testid="bv-metrics">
      <Card className="border-t-[3px] border-t-amber-500">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">Manual cost</CardTitle>
          <DollarSign className="h-4 w-4 text-cp-mod" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-cp-mod">
            {formatMoney(savings?.total_manual_cost)}
          </div>
          <p className="text-xs text-muted-foreground">Estimated effort × bill rate</p>
        </CardContent>
      </Card>

      <Card className="border-t-[3px] border-t-cp-indigo">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">LLM cost</CardTitle>
          <Cpu className="h-4 w-4 text-cp-indigo" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-cp-indigo">
            {formatMoney(tokenUsage?.total_llm_cost, 4)}
          </div>
          <p className="text-xs text-muted-foreground">
            {(tokenUsage?.total_tokens || 0).toLocaleString()} tokens
            {deploys > 0 && <> · {deploys} deploy{deploys === 1 ? '' : 's'}</>}
          </p>
        </CardContent>
      </Card>

      <Card className="border-t-[3px] border-t-green-600">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">You save</CardTitle>
          <TrendingUp className="h-4 w-4 text-cp-ok" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-cp-ok">
            {formatMoney(savings?.total_savings)}
          </div>
          <p className="text-xs text-muted-foreground">Manual value − LLM cost</p>
        </CardContent>
      </Card>

      <Card className="border-t-[3px] border-t-slate-400">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">Tickets resolved</CardTitle>
          <Ticket className="h-4 w-4 text-cp-muted" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{savings?.ticket_count ?? 0}</div>
          <p className="text-xs text-muted-foreground flex items-center gap-1">
            in period
            {deploys > 0 && (
              <>
                <Rocket className="h-3 w-3" /> {deploys} deployed
              </>
            )}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
